export function isAccountMemberOfOrganization(orgRole, orgStatus, orgIds) {
    for (const orgId of Object.keys(orgRole)) {
        if (orgIds.includes(orgId)) {
            return true;
        }
    }
    for (const orgId of Object.keys(orgStatus)) {
        if (orgIds.includes(orgId)) {
            return true;
        }
    }
    return false;
}
